<template>
  <div class="content">
    <div class="page">
      <h2>能耗分析</h2>
      <div class="message">
        通过能源消费结构，楼层能耗对比，重点耗能设备分析等多种分析方式，报表分析可以帮助物业管理人员计算特定房间或人均能耗，实现自主能源审计管理。报表可以自动生成，按实际需要实现手动或自动打印，供调度和运行管理人员使用。
      </div>
      <img src="../../../../assets/image/buildingImg/img2.png" alt="" />
    </div>
  </div>
</template>
 
<script>
export default {
  components: {},
  name: "",
  data() {
    return {};
  },

  methods: {},
};
</script>
 
<style scoped lang="scss">
.content {
  padding: 0 16%;
  box-sizing: border-box;
  min-height: calc(100vh - 387px);
  width: 100%;
  margin-bottom: 50px;
  .page {
    margin-top: 50px;
    width: 100%;
    height: 720px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 30px;
    // position: relative;
    text-align: center;
    > h2 {
      text-align-last: left;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #333333;
      margin: 10px 0 30px 0;
    }
    .message {
      text-align-last: left;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #6b6b6b;
      margin-bottom: 50px;
    }
  }
}
</style>